import { canViewIncidentType } from '@/composables/permissionHelper'
import { useDisplayModeStore } from '@/store/displayMode'
import { DocumentQuerySelect } from '@/types/Query'

export type IncidentReductionSettings = {
  deleteOutside: boolean
  select: DocumentQuerySelect[]
  dropInstructions: {
    y: number | null | boolean | string
  }
}
export type SerializedIncidentReducer = {
  reducerType: string
}

export abstract class IncidentReducer {
  protected abstract readonly _reducerType: string

  abstract canReduce(): Promise<boolean>

  abstract getIncidentReduction(): Promise<IncidentReductionSettings>
  get reducerType(): string {
    return this._reducerType
  }

  static fromSerialized(serialized: SerializedIncidentReducer): IncidentReducer {
    if (serialized.reducerType === 'penState') {
      return PenStateIncidentReducer.fromSerialized(serialized)
    }
    throw new Error(`Cannot deserialize incident reducer type '${serialized.reducerType}'`)
  }

  serialize(): SerializedIncidentReducer {
    return {
      reducerType: this.reducerType,
    }
  }
}

export class PenStateIncidentReducer extends IncidentReducer {
  _reducerType: string = 'penState'

  static fromSerialized(_serialized: SerializedIncidentReducer): PenStateIncidentReducer {
    return new PenStateIncidentReducer()
  }
  async canReduce() {
    if (!canViewIncidentType('penState')) return false

    await useDisplayModeStore().ensureForInstance()
    const displayMode = useDisplayModeStore().getDisplayMode()
    if (!displayMode?.enablePenStateIncidentChartReduction) return false

    return true
  }

  async getIncidentReduction() {
    const result: IncidentReductionSettings = {
      deleteOutside: true,
      select: [{ key: 'type', operator: '==', value: 'penState' }],
      dropInstructions: { y: 0 },
    }
    return result
  }
}
